module.exports = __webpack_public_path__ + "img/contact img@2x.41906db8.png";